module.exports = __webpack_public_path__ + "static/media/WILLOW.b7a68bd9.JPG";